import {defineMessages, useIntl} from 'react-intl';
import {view} from '@sail/ui/deprecated';
import {ChatButtonOptions} from '@stripe-internal/conversations-ui';

const messages = defineMessages({
  cantSignIn: {
    id: 'mse_inline_data.universal_help_sign_in.cant_sign_in',
    description: "Label for the i-can't-sign-in button.",
    defaultMessage: "I can't sign in",
  },
});

export const CantSignInLabel = () => {
  const intl = useIntl();

  return (
    <>
      <view.div
        data-testid="uh-sign-in-cant-sign-in-label"
        css={{margin: 'small', alignX: 'end'}}
      >
        <ChatButtonOptions
          options={[
            {
              value: 'cant-sign-in',
              label: intl.formatMessage(messages.cantSignIn),
            },
          ]}
          selectedOptionId="cant-sign-in"
        />
      </view.div>
    </>
  );
};
